import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const getLaunchUrl = (state: SalesCheckinRootState): string => state.config.urls?.launchUrl || '';
